import { EmployeeProperties } from "../types/employee.type";
import { GroupMemberProperties } from "../types/groupMember.type";
import { ProfileProperties } from "../types/profile.type";
import { UserProperties } from "../types/user.type";

export const memberFormatted = (record: GroupMemberProperties) => {
	let formatted = {
		groupMemberId: record?.groupMemberId,
		user: {
			...(record?.user as UserProperties),
			employee: [
				{
					...(record?.employee as EmployeeProperties),
				},
			],
			profile: {
				...(record?.profile as ProfileProperties),
			},
			teamsMemberFees:
				record?.teamsMemberFees &&
				record.teamsMemberFees[0]?.teamsMemberFeeItems!.map((item) => ({
					...item,
					isNew: false,
				})),
			teamsMemberFeeId: record?.teamsMemberFees?.[0]?.teamsMemberFeeId,
		},
	};

	return formatted;
};
